<template>
    <vx-card id="loader">

        <vs-row vs-w="12">
            <vs-col vs-offset="0" vs-type="flex" vs-justify="left" vs-align="center" vs-w="6">
                <div class="vx-row header-title mb-4">
                    <h1>Справочник алгоритмов</h1>
                </div>
            </vs-col>
        </vs-row>

        <div class="vx-row header-title ml-1 mt-3 mb-1">
            <h4>Фильтры</h4>
        </div>

        <!-- <vs-button color="warning" @click="updateSites" type="filled" class="mb-5">Обновить сайты</vs-button> -->

        <div class="vx-row mb-2">
            <div class="vx-col w-1/2">
                <div class="mt-1">
                    <vs-input v-model="form.algoritmname" autocomplete="off" label="По названию алгоритма"
                        class="mt-1 w-full" />
                </div>
            </div>
            <div class="vx-col w-1/2">
                <div class="mt-1 vx-col">
                    <label class="vs-input--label">
                        По статусу активности
                    </label>
                    <v-select :options="dicts.statuses" label="name" placeholder="Выберите статус активности"
                        class="w-full" v-model="form.status">
                    </v-select>
                </div>
            </div>
        </div>

        <div class="vx-row mb-2">
            <div class="vx-col w-1/2 mb-1">


                <div class="mt-1 vx-col">
                    <label class="vs-input--label">
                        По типу DSP
                    </label>
                    <v-select :options="dicts.dspTypes" label="name" placeholder="Выберите тип DSP" class="w-full"
                        v-model="form.dsptype">
                    </v-select>
                </div>


            </div>
            <div class="vx-col w-1/2 mb-1">
                <div class="mt-1 vx-col">
                    <label class="vs-input--label">
                        По формату данных
                    </label>
                    <v-select :options="dicts.adTypes" label="name" placeholder="Выберите формат данных" class="w-full"
                        v-model="form.adtype">
                    </v-select>
                </div>
            </div>
        </div>


        <vs-button class="mt-2" color="success" @click="loadAlgoritms()" type="filled">
            Применить
        </vs-button>



        <vs-table v-model="selected2" @selected="handleSelected" :data="algoritms" search max-items="10" pagination
            class="mt-5">

            <template slot="thead">
                <vs-th>
                    Id
                </vs-th>
                <vs-th>
                    Название алгоритма
                </vs-th>
                <vs-th>
                    Тип DSP
                </vs-th>
                <vs-th>
                    Статус активности
                </vs-th>
                <vs-th>
                    Формат данных
                </vs-th>
            </template>

            <template slot-scope="{data}">
                <vs-tr :data="tr" :key="indextr" v-for="(tr, indextr) in data">
                    <vs-td>{{tr.id}}</vs-td>
                    <vs-td>{{tr.description}}</vs-td>
                    <vs-td>{{tr.dspTypeName}}</vs-td>
                    <vs-td>
                        <vs-checkbox icon="check" color="rgb(38, 187, 174)" v-model="tr.active"
                            @click.native="showToggleAlgoritmModal()"></vs-checkbox>

                    </vs-td>
                    <vs-td>{{tr.adTypeName}}</vs-td>
                </vs-tr>
            </template>
        </vs-table>


        <vx-card title="Редактирование данных алгоритма" id="loader" class="mt-5">



            <div class="vx-row mb-2">
                <div class="vx-col w-1/4  mb-1">

                    <div class="mt-1">
                        <vs-input label="Id алгоритма" v-model="editform.id" class="w-full" readonly disabled
                            type="number" min="0" />
                    </div>

                </div>
            </div>
            <div class="vx-row mb-2">
                <div class="vx-col w-1/2  mb-1">
                    <div class="mt-1">
                        <vs-input v-model="editform.algoritmname" autocomplete="off" label="Название алгоритма"
                            class="mt-1 w-full" />
                    </div>
                </div>
                <div class="vx-col w-1/2">

                    <div class="mt-1 vx-col">
                        <label class="vs-input--label">
                            Название типа DSP
                        </label>
                        <v-select :options="dicts.dspTypes" label="name" disabled class="w-full"
                            v-model="editform.dsptypename">
                        </v-select>
                    </div>
                </div>
            </div>

            <div class="vx-row mb-2">
                <div class="vx-col w-1/2 mb-1">
                    <div class="mt-1">
                        <label class="vs-input--label">
                            Статус активности
                        </label>
                        <v-select :options="dicts.statuses" label="name" class="w-full" :clearable=false
                            v-model="editform.status">
                        </v-select>
                    </div>
                </div>
                <div class="vx-col w-1/2 mb-1">
                    <div class="mt-1 vx-col">
                        <label class="vs-input--label">
                            Формат данных
                        </label>
                        <v-select :options="dicts.adTypes" label="name" disabled class="w-full"
                            v-model="editform.adtypename">
                        </v-select>
                    </div>
                </div>
            </div>

            <div class="vx-row mb-2">

                <div class="vx-col w-1/3 mb-1 pt-3">
                    <div class="mt-3 mb-3">
                        <vs-button class="mt-3" color="success" @click="showAlgoritmModal()" type="filled">
                            Сохранить изменения
                        </vs-button>

                    </div>
                </div>
            </div>


            <sweet-modal ref="toggleAlgoritmModal1" hide-close-button icon="error" title="Изменение статуса алгоритма">
                <div class="mb-5">Вы действительно хотите изменить статус алгоритма?</div>

                <vs-button class="mr-2" color="danger" @click="toggleAlgoritmStatus()" type="filled">
                    {{ (this.algoritm? this.algoritm.active: false) ? 'Включить алгоритм' : 'Выключить алгоритм' }}
                </vs-button>
                <vs-button class="mr-2" color="danger" @click="cancelAlgoritmStatusChange1()" type="filled">
                    Отменить
                </vs-button>
            </sweet-modal>

            <sweet-modal ref="toggleAlgoritmModal2" hide-close-button icon="error" title="Изменение статуса алгоритма">
                <div class="mb-5">Вы действительно хотите изменить статус алгоритма?</div>

                <vs-button class="mr-2" color="danger" @click="saveChanges(true)" type="filled">
                    {{ (this.editform ? (this.editform.status ? this.editform.status.name  : ""):"") == 'Активный' ? 'Включить алгоритм' : 'Выключить алгоритм' }}
                </vs-button>
                <vs-button class="mr-2" color="danger" @click="cancelAlgoritmStatusChange2()" type="filled">
                    Отменить
                </vs-button>

            </sweet-modal>




        </vx-card>




    </vx-card>
</template>


<script>
    import vSelect from 'vue-select'
    import axios from 'axios'
    import {
        SweetModal,
        SweetModalTab
    } from 'sweet-modal-vue'



    export default {
        name: 'algoritms',
        data() {
            return {
                algoritms: [],
                selected: {},
                selected2: [],
                algoritm: undefined,
                form: {
                    algoritmname: '',
                    status: null,
                    dsptype: null,
                    adtype: null,
                },

                editform: {
                    id: null,
                    algoritmname: '',
                    dsptypename: '',
                    status: null,
                    adtypename: '',
                    url: '',
                },

                errors: {
                    algoritmname: '',
                    status: null,
                },

                dicts: {
                    statuses: [{
                            id: 0,
                            name: 'Не активный'
                        },
                        {
                            id: 1,
                            name: 'Активный'
                        }
                    ],
                    adtypes: [],
                    dsptypes: [],

                },



            }
        },
        components: {
            vSelect,
            SweetModal,
            SweetModalTab
        },
        methods: {
            test() {
                debugger
                var a = 2
            },

            cancelAlgoritmStatusChange1() {
                this.$refs.toggleAlgoritmModal1.close();
                this.algoritm.active = !this.algoritm.active;
            },
            showToggleAlgoritmModal() {
                debugger
                this.$refs.toggleAlgoritmModal1.open();
            },
            showAlgoritmModal() {
                debugger
                if (this.algoritm.active != (this.editform.status.name == 'Активный')) {
                    this.$refs.toggleAlgoritmModal2.open();
                } else {
                    this.saveChanges(false)

                }
            },
            cancelAlgoritmStatusChange2() {
                debugger
                this.$refs.toggleAlgoritmModal2.close();
                //this.algoritm.active = !this.algoritm.active;
                
                this.editform.status = this.algoritm.active? {
                    id: 1,
                    name: 'Активный'
                } : {
                    id: 0,
                    name: 'Не активный'
                }
                this.editform.algoritmname =  this.algoritm.description
            },
            saveChanges(algstatuschanged) {
                this.$refs.toggleAlgoritmModal2.close();
                debugger
                const params = {
                    id: this.editform.id,
                    active: this.editform.status.name == 'Активный',
                    description: this.editform.algoritmname,
                };
                debugger
                this.$axios({
                    method: 'PUT',
                    url: 'algoritms/' + this.editform.id,
                    params: params,
                    errors: this.errors,
                    success: (response) => {
                        this.$vs.loading.close("#loader > .con-vs-loading");

                        if (algstatuschanged){
                        this.$vs.notify({
                            title: "Успешно обновлено",
                            text: "Сообщение на изменение статуса алгоритма отрпавлено в DSP. Статус алгоритма в БД успешно обновлен.",
                            color: "success",
                        });

                        }
                        else {

                        this.$vs.notify({
                            title: "Успешно обновлено",
                            text: "Алгоритм успешно обновлен",
                            color: "success",
                        });

                        }
                        this.loadAlgoritms();

                    },
                    catch: (err) => {
                        this.$vs.loading.close("#loader > .con-vs-loading");
                        if (err.request.status == 422 && err.data.errors['']) {
                            const error = err.data.errors[''][0];
                            return this.$vs.notify({
                                title: "Внимание!",
                                text: error,
                                color: "danger",
                            });
                        }

                        return this.$vs.notify({
                            title: "Внимание!",
                            text: "Ошибка при обновлении алгоритма!",
                            color: "danger",
                        });
                    }
                })
            },
            toggleAlgoritmStatus() {
                this.$refs.toggleAlgoritmModal1.close();
                this.$vs.loading({
                    container: '#loader',
                    type: 'sound'
                });
                debugger


                this.$axios({
                    method: 'PATCH',
                    url: 'algoritms/' + this.algoritm.id + '/status',
                    params: {
                        id: this.algoritm.id,
                        active: this.algoritm.active
                    },
                    errors: this.errors,
                    success: () => {
                        this.$vs.loading.close("#loader > .con-vs-loading");


                        this.editform.status = this.algoritm.active ? {
                            id: 1,
                            name: 'Активный'
                        } : {
                            id: 0,
                            name: 'Не активный'
                        }


                        this.$vs.notify({
                            title: "Успешно обновлено",
                            text: "Сообщение на изменение статуса алгоритма отрпавлено в DSP. Статус алгоритма в БД успешно обновлен.",
                            color: "success",
                        });
                    },
                    catch: (err) => {
                        this.$vs.loading.close("#loader > .con-vs-loading");
                        if (err.request.status == 422 && err.data.errors['']) {
                            const error = err.data.errors[''][0];
                            return this.$vs.notify({
                                title: "Внимание!",
                                text: error,
                                color: "danger",
                            });
                        }

                        return this.$vs.notify({
                            title: "Внимание!",
                            text: "Ошибка при обновлении статуса алгоритма!",
                            color: "danger",
                        });
                    }
                })

            },

            handleSelected(tr) {

                debugger
                this.editform.id = tr.id
                this.editform.algoritmname = tr.description
                this.editform.dsptypename = tr.dspTypeName
                this.editform.status = tr.active ? {
                    id: 1,
                    name: 'Активный'
                } : {
                    id: 0,
                    name: 'Не активный'
                }

                this.algoritm = tr

                this.editform.adtypename = tr.adTypeName
            },

            clearSelected() {

                debugger
                this.editform.id = ''
                this.editform.algoritmname = ''
                this.editform.dsptypename = ''
                //this.editform.status = tr.active ? {id: 1, name: 'Активный'} : {id: 0, name: 'Не активный'}


                this.editform.adtypename = ''
                //this.editform.url = ''
            },

            loadAlgoritms() {
                this.$vs.loading({
                    container: '#loader',
                    type: 'sound'
                });

                debugger
                const params = {
                    algoritmname: this.form.algoritmname,
                    dsptypeid: this.form.dsptype ? this.form.dsptype.id : null,
                    status: this.form.status ? this.form.status.id == 1 : null,
                    adtypeid: this.form.adtype ? this.form.adtype.id : null,
                };

                this.axios.all([
                        this.axios.get('algoritms', {
                            params
                        }),
                        this.axios.get('algoritms/dicts')
                    ])
                    .then(axios.spread((algoritms, dicts) => {
                        this.algoritms = algoritms.data;
                        debugger
                        this.dicts.adTypes = dicts.data.adTypes;
                        this.dicts.dspTypes = dicts.data.dspTypes;
                        this.clearSelected()

                    }))
                    .catch((err) => {
                        this.$vs.notify({
                            title: "Ошибка!",
                            text: "Ошибка при загрузке списка алгоритмов.",
                            color: "danger",
                        });
                    })
                    .finally(() => {
                        this.$vs.loading.close("#loader > .con-vs-loading");
                    });


            },

        },
        mounted() {
            this.loadAlgoritms();
        }
    }
</script>

<style lang="scss">
    table {
        tr.selected {
            cursor: text !important;
        }
    }

    thead {
        th {
            font-size: 15px !important;

            .sort-th {
                i {
                    font-size: 19px;
                }
            }
        }
    }

    .header-title {
        flex-direction: column;
    }

    .textarea {
        border: 1px solid lightgrey !important;
    }
</style>